import { render, staticRenderFns } from "./OurHousesDetails.vue?vue&type=template&id=107b1f4f&scoped=true&"
import script from "./OurHousesDetails.vue?vue&type=script&lang=js&"
export * from "./OurHousesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107b1f4f",
  null
  
)

export default component.exports